var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "surface23684409",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M24.667,8H11.333A3.333,3.333,0,0,0,8,11.333V24.667A3.334,3.334,0,0,0,11.333,28H24.667A3.334,3.334,0,0,0,28,24.667V11.333A3.334,3.334,0,0,0,24.667,8Zm-10,16.25H12.583V15.917h2.083Zm.011-10a1.407,1.407,0,0,1-1.053.413,1.388,1.388,0,0,1-1.05-.426,1.455,1.455,0,0,1-.409-1.045,1.405,1.405,0,0,1,.409-1.042,1.571,1.571,0,0,1,2.1,0,1.407,1.407,0,0,1,.405,1.042A1.445,1.445,0,0,1,14.678,14.253Zm9.572,10H22.167V19.619c0-1.291-.744-2.036-1.667-2.036a1.757,1.757,0,0,0-1.235.612,1.951,1.951,0,0,0-.431,1.3V24.25H16.75V15.917h2.083v1.318h.033a2.955,2.955,0,0,1,2.677-1.522c1.665,0,2.707,1.245,2.707,3.434Zm0,0",
    transform: "translate(-8 -8)",
    fill: "#00a093"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.aa02390d32c367a05b7c00cfeecf67a5.svg";
export { ForwardRef as ReactComponent };